export default __webpack_public_path__ + "static/media/icon_USDC.f08e02b1.svg";